<template>
  <div>
    <!-- <AppHeader v-if="showHeader" /> -->
    <!-- <menuPage v-else-if="$route.path !== '/the-login'" /> -->
    <router-view :countryList="$store.getters.getLanguage"></router-view>
    <!-- 传递语言设置 -->
  </div>
</template>

<script>
// import AppHeader from "./components/AppHeader.vue";
// import menuPage from "./admin/menuPage.vue";

export default {
  name: "App",
  components: {
    // AppHeader,
    // menuPage,
  },
  data() {
    return {};
  },
  methods: {},
  watch: {},
  mounted() {},
};
</script>

<style>
@font-face {
  font-family: "PlutoSansBold";
  src: url("@/assets/fonts/Montserrat-Bold.ttf") format("opentype");
}

@font-face {
  font-family: "PlutoSansRegular";
  src: url("@/assets/fonts/Montserrat-Regular.ttf") format("opentype");
}

@media (max-width: 768px) {
  .el-message {
    width: 90% !important;
  }
}
.el-message {
  position: fixed;
  top: 50% !important; /* 垂直居中 */
  left: 50% !important; /* 水平居中 */
  transform: translate(-50%, -50%) !important; /* 调整位置 */
  z-index: 9999; /* 确保在最上层 */
}
body {
  margin: 0;
  font-family: "PlutoSansRegular";
}
.ql-container.ql-snow {
  font-family: "PlutoSansRegular" !important;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
</style>
